import { MetadataActions } from 'invision-core';
export var RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_CONSTANTS = {
  BEGIN: 'RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_BEGIN',
  SUCCESS: 'RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_SUCCESS',
  FAILURE: 'RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_FAILURE'
};
export var retrieveCustomerDataForOttDashboard = function retrieveCustomerDataForOttDashboard() {
  return function (dispatch) {
    dispatch({
      type: RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_CONSTANTS.BEGIN
    });
    return MetadataActions.codes.fetchInteractionTypesPromise(dispatch).then(function () {
      dispatch({
        type: RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_CONSTANTS.SUCCESS
      });
    }, function (error) {
      dispatch({
        type: RETRIEVE_CUSTOMER_INFO_FOR_OTT_DASHBOARD_CONSTANTS.FAILURE,
        payload: error
      });
    });
  };
};